import { createSelector } from "@reduxjs/toolkit"
import { initialState } from "./pickupLocationSlice"

export const selectDomain = (state) => state.pickupLocation || initialState

export const makeSelectAll = createSelector(selectDomain, (state) => state.all)

export const makeSelectOne = createSelector(selectDomain, (state) => state.one)

export const makeSelectQuery = createSelector(
  selectDomain,
  (state) => state.query,
)

export const makeSelectChosenLocation = createSelector(
  selectDomain,
  (state) => state.chosen_location,
)
